import { ActionContext } from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Ajax from '@/lib/ajaxWeixin';

interface WeixinState extends ListState<any> {
}

class WeixinModule extends ListModule<WeixinState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false
    }
    actions = {
        /**
         * 获取微信登录二维码
        */
        async getWxLoginQrCode(context: ActionContext<WeixinState, any>, payload: any) {
            const reponse = await Ajax.get(
                `/weixin/getWxLoginQrCode?loginId=${payload.data.loginId}`,
                { responseType: 'blob' })
            let blob = new Blob([reponse.data], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        },
        async getSubscribeQrCode(context: ActionContext<WeixinState, any>, payload: any) {
            const reponse = await Ajax.get('/weixin/getSubscribeQrCode', { responseType: 'blob' })
            let blob = new Blob([reponse.data], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        },
        async isSubscribed(context: ActionContext<WeixinState, any>) {
            const reponse = await Ajax.get('/weixin/isSubscribed')
            return reponse.data;
        },
        async getProductQrCode(context: ActionContext<WeixinState, any>, payload: any) {
            const reponse = await Ajax.get('/weixin/getProductQrCode?productNo=' + payload.data.productNo, { responseType: 'blob' })
            let blob = new Blob([reponse.data], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        }
    };
    mutations = {
        setCurrentPage(state: WeixinState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: WeixinState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const weixinModule = new WeixinModule();
export default weixinModule;